export default "__VITE_ASSET__DUczq89o__"